import axios from "axios";
axios.defaults.baseURL =
  process.env.REACT_APP_API_BASE_URL || `http://localhost:5000`;
axios.defaults.withCredentials = true;

const extractApiError = (errAxios) => {
  return errAxios.response
    ? errAxios.response.data
    : { error: { message: "API not reachable" } };
};

// async => wrap normal returns with a promise!
export const loginUser = async (userCredentials) => {
  try {
    const response = await axios.post(`/users/login`, userCredentials);
    return response.data;
  } catch (err) {
    return extractApiError(err);
  }
};

export const googleLoginUser = async (userCredentials) => {
  // call login route passing in email & password
  try {
    const response = await axios.post(`/users/googleLogin`, userCredentials);
    return response.data;
  } catch (err) {
    return extractApiError(err);
  }
};

export const logOutUser = async () => {
  // console.log('Logging out at backend...');
  try {
    const response = await axios.get("/users/logout");
    // console.log('Result: ', response.data);
    return response.data;
  } catch (err) {
    return extractApiError(err);
  }
};

export const registerUser = async (data) => {
  try {
    const response = await axios.post("/users", data);
    return response.data;
  } catch (err) {
    return extractApiError(err);
  }
};

export const addBillAddress = async (id, data) => {
  try {
    const response = await axios.post(`/users/${id}/billaddress`, data);
    return response.data;
  } catch (err) {
    return extractApiError(err);
  }
};

export const addDelAddress = async (id, data) => {
  try {
    const response = await axios.post(`/users/${id}/deladdress`, data);
    return response.data;
  } catch (err) {
    return extractApiError(err);
  }
};

export const setDefaultAddress = async (uid, did) => {
  try {
    const response = await axios.patch(`/users/${uid}/default/${did}`);
    return response.data;
  } catch (err) {
    return extractApiError(err);
  }
};

export const updateDelAddress = async (uid, did, data) => {
  try {
    const response = await axios.patch(`/users/${uid}/deladdress/${did}`, data);
    return response.data;
  } catch (err) {
    return extractApiError(err);
  }
};

export const authenticateUser = async () => {
  try {
    const response = await axios.post(`/users/auth`);
    return response.data;
  } catch (err) {
    let error = extractApiError(err);
    // console.log(error);
    return error;
  }
};

export const verifyUser = async (token) => {
  try {
    const response = await axios.post(`/users/verify`, { token: token });
    return response.data;
  } catch (err) {
    let error = extractApiError(err);
    return error;
  }
};

export const updateOrder = async (data, id) => {
  try {
    const response = await axios.patch(`/api/payments/${id}`, data);
    return response.data;
  } catch (error) {
    return error;
  }
};
